<template>
  <div class="footer">
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="footer_left">
              <div class="beian">
                <a href="https://beian.miit.gov.cn">
                  琼ICP备2024040097号
                </a>
              </div>
              <div class="gongsi">
                  <span>Copyright ©2023 海南佰曦科技有限公司</span>
              </div>
        </div>
      </el-col>
      <el-col :span="0">
        <!-- <div class="footer_right">
            <img src="http://www.dr81.cn/gzh.jpg">
            <span>官方公众号</span>
        </div> -->
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeIndex: '1'
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  }
</script>

<style>
  .footer {
      width: 100%;
      margin: 0px auto;
      overflow: hidden;
  }
  .footer_left{
      line-height: 30px;
      padding-top: 20px;
      padding-bottom: 20px;
      font-size: 14px;
      color: #EAEAEA;
      text-align: center;
  }

  .footer_left a{
      color: #EAEAEA;
  }

  .footer_right{
      float: right;
      padding-top: 20px;
      padding-right: 20px;
      padding-bottom: 10px;
  }

  .footer_right img{
      width: 100px;
      height: 100px;
  }

  .footer_right span{
      display: block;
      text-align: center;
      padding-top: 2px;
      color: #EAEAEA;
      font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/front/common/Footer.vue